/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import React from 'react'

import DocumentContainer from 'containers/Document'
import DocumentPane from 'components/DocumentPane'
import DocumentsSidebar from 'components/DocumentsSidebar'
import Layout from 'components/Layout'
import Logo from 'components/Logo'
import SiteTitle from 'components/SiteTitle'
import Nav from 'components/Nav'
import Helmet from 'react-helmet'

const Document = ({
  barPlotNavigation,
  className,
  document,
  documentNavigation,
}) => {
  return (
    <Layout gridName="docsGrid" className={className}>
      <Helmet title={document.title} />
      <Logo className="logoRegion" />
      <SiteTitle className="titleRegion" title="651 - Gateway" />
      <Nav className="navRegion" />
      <DocumentsSidebar
        documentNavigation={documentNavigation}
        barPlotNavigation={barPlotNavigation}
        className="sidebarRegion"
      />
      <DocumentPane document={document} className="fullPaneRegion region" />
    </Layout>
  )
}

export default DocumentContainer(Document)
